import {
  CONTENT_SET_TYPES,
  PAYMENT_SYSTEM_TYPES,
  RENT_LENGTH_TYPES,
  SET_PRICING_PAYMENT_METHOD_TYPES,
  SET_PRICING_PAYMENT_METHOD_TYPES_LABELS,
  SHOWSET_TYPE_LABELS,
  SHOWSET_TYPES
} from '../../app/core/constants'
import moment from 'moment'
import { getFilteredKeys, multiSelectWithAll } from '../common/directives/contentItems/ciHelpers'

/**
 * EditAddonCtrl controller
 */

// preload drag'n'drop image
const dragndropImg = new window.Image()
dragndropImg.src = require('./img/dragndrop.png')

/**
 * EditAddonCtrl controller
 *
 * @class EditAddonCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:EditAddonCtrl
 */
/* @ngInject */
export default function EditAddonCtrl (
  $location,
  $scope,
  $uibModalInstance,
  ChannelSet,
  LiveEventSet,
  MultiSet,
  NetworkCurrency,
  ShowSet,
  VODSet,
  allowedExclusivePaymentSystems,
  authSvc,
  cs,
  isViewMode,
  networkId,
  subscription,
  type
) {
  var vm = this
  vm.allowedExclusivePaymentSystems = allowedExclusivePaymentSystems
  vm.rentLengthTypes = RENT_LENGTH_TYPES
  vm.payment_system_types = PAYMENT_SYSTEM_TYPES
  vm.ready = false
  vm.type = type
  vm.isViewMode = isViewMode
  vm.showSetTypeLabels = SHOWSET_TYPE_LABELS
  vm.SC_ENABLED = window.ENV.APP_SC_ENABLED === 'true'
  vm.content_set_types = CONTENT_SET_TYPES

  vm.cs = cs
  vm.set_pricing_payment_method_types = SET_PRICING_PAYMENT_METHOD_TYPES
  vm.set_pricing_payment_method_types_labels = SET_PRICING_PAYMENT_METHOD_TYPES_LABELS
  vm.types = Object.keys(vm.set_pricing_payment_method_types)
  if (window.ENV.APP_CS_PER_ITEM_ENABLED !== 'true') {
    vm.types = ['PER_SET']
  }
  if (vm.type === 'liveEventSets') {
    vm.types = ['PER_ITEM']
  }

  vm.FEATURE_EXCLUSIVE_PAYMENT_METHODS_ENABLED = authSvc.hasEnabledFlag('FEATURE_EXCLUSIVE_PAYMENT_METHODS_ENABLED')

  vm.hasAccess = function (access) {
    return authSvc.hasAccess(access)
  }

  vm.monetizationType = ['buy', 'rent']
  vm.nestedTyped = ['EPISODE', 'SEASON']
  vm.allItems = []
  vm.subscription = subscription

  vm.cs.$opened = true

  vm.unlimitedValue = 'Unlimited'

  vm.showSet_types = SHOWSET_TYPES

  vm.items = [{}]

  if (vm.type === 'channelSets') {
    if (!vm.cs.pricing.rent.rentLengthOverride) {
      vm.cs.pricing.rent.$periodType = subscription.$periodType
      vm.cs.pricing.rent.$dueDate = subscription.$dueDate
      vm.cs.pricing.rent.dueDate = subscription.dueDate
      vm.cs.pricing.rent.period = subscription.length
      vm.cs.pricing.rent.timeUnit = subscription.lengthType ? subscription.lengthType === 'Days' ? 'DAY' : 'MONTH' : null
    }
  }
  vm.getFilteredKeys = getFilteredKeys

  vm.multiSelectWithAll = multiSelectWithAll

  vm.hasFlag = function (flag) {
    return authSvc.hasEnabledFlag(flag)
  }

  vm.setRentLengthOverride = function () {
    vm.cs.pricing.rent.periodUnlimited = false
    if (!vm.cs.pricing.rent.rentLengthOverride && subscription.$periodType === 'DEFAULT') {
      vm.cs.pricing.rent.$periodType = 'DEFAULT'
      vm.cs.pricing.rent.period = subscription.length
      vm.cs.pricing.rent.timeUnit = subscription.lengthType === 'Days' ? 'DAY' : 'MONTH'
    }
    if (!vm.cs.pricing.rent.rentLengthOverride && subscription.$periodType === 'UNLIMITED') {
      vm.cs.pricing.rent.$periodType = 'DEFAULT'
      vm.cs.pricing.rent.period = 0
      vm.cs.pricing.rent.timeUnit = 'DAY'
      vm.cs.pricing.rent.autoPay = false
    }
    if (!vm.cs.pricing.rent.rentLengthOverride && subscription.$periodType === 'DUE_DATE') {
      vm.cs.pricing.rent.$periodType = 'DUE_DATE'
      vm.cs.pricing.rent.$dueDate = subscription.$dueDate
      vm.cs.pricing.rent.dueDate = subscription.dueDate
      vm.cs.pricing.rent.autoPay = false
    }
  }

  vm.setAllPrices = function (type, arr = vm.allItems, price = 0) {
    arr.forEach(i => { i.pricing[type].amount = price })
  }

  /**
   * Table state for pageable request
   *
   * @memberof mwApp/packages.controller:AddAddonsCtrl
   */
  vm.initTableState = {
    page: 0,
    count: 1000,
    last: false
  }

  vm.tableState = angular.copy(vm.initTableState)

  vm.getAllItems = function (cs) {
    vm.allItems = []
    switch (vm.cs.itemType) {
      case 'EPISODE':
        for (const { seasons, tvShowName } of cs) {
          for (const season of seasons) {
            season.episodes.forEach(episode => { episode.tvShowName = tvShowName })
            vm.allItems.push(...season.episodes)
          }
        }
        break
      case 'SEASON':
        for (const { seasons, tvShowName } of cs) {
          seasons.forEach(s => { s.tvShowName = tvShowName })
          vm.allItems.push(...seasons)
        }
        break
      default:
        vm.allItems.push(...cs)
        break
    }
  }

  vm.getPrices = function (tableState) {
    const ids = {
      networkId,
      subscriptionId: subscription.id || 0,
      setId: cs.id || 0
    }
    switch (type) {
      case 'vodSets':
        vm.label = 'VOD'
        return VODSet.loadCustomPrices(ids, tableState)
      case 'channelSets':
        vm.label = 'TV Channel'
        return ChannelSet.loadCustomPrices(ids, tableState)
      case 'liveEventSets':
        vm.label = 'Live Event'
        return LiveEventSet.loadCustomPrices(ids, tableState)
      case 'tvShowSets':
        vm.label = 'TV Show'
        return ShowSet.loadCustomPrices(ids, tableState)
      case 'multiSets':
        vm.label = 'Multi'
        return MultiSet.loadItemsForSubscription(ids)
    }
  }

  vm.getPrices(vm.initTableState).then(data => {
    if (vm.type === 'multiSets') {
      vm.multiSetsContent = {}
      vm.contentSetsTypes = Object.keys(CONTENT_SET_TYPES).filter(k => k !== 'multiSets')
      vm.contentSetsTypes = vm.contentSetsTypes.filter(key => data[key].length)
      vm.contentSetsTypes.forEach(key => {
        vm.multiSetsContent[key] = {
          is_open: true,
          sets: data[key]
        }
      })
    } else {
      vm.contentItems = data.content
      vm.cachedContentItems = angular.copy(vm.contentItems)
      if (vm.type !== 'tvShowSets') {
        vm.contentItems.forEach(item => {
          const contentItem = vm.cs.contentItems.find(ci => ci.contentId === item.contentId)
          if (contentItem) {
            if (vm.cs.$rentEnabled) {
              item.pricing.rent.amount = contentItem.pricing.rent.amount
            }
            if (vm.cs.$buyEnabled) {
              item.pricing.buy.amount = contentItem.pricing.buy.amount
            }
          }
        })
      } else {
        vm.contentItems.forEach((show, showIndex) => {
          if (vm.cs.itemType === vm.showSet_types.tvShow) {
            const contentItem = vm.cs.contentItems.find(ci => ci.tvShowId === show.tvShowId)
            if (contentItem) {
              if (vm.cs.$rentEnabled) {
                show.pricing.rent.amount = contentItem.pricing.rent.amount
              }
              if (vm.cs.$buyEnabled) {
                show.pricing.buy.amount = contentItem.pricing.buy.amount
              }
            }
          } else {
            show.seasons.forEach((season, seasonIndex) => {
              if (vm.cs.itemType === vm.showSet_types.season) {
                if (vm.cs.contentItems[showIndex]) {
                  const curSeason = vm.cs.contentItems[showIndex].seasons.find(s => s.seasonId === season.seasonId)
                  if (curSeason) {
                    if (vm.cs.$rentEnabled) {
                      season.pricing.rent.amount = curSeason.pricing.rent.amount
                    }
                    if (vm.cs.$buyEnabled) {
                      season.pricing.buy.amount = curSeason.pricing.buy.amount
                    }
                  }
                }
              } else {
                season.episodes.forEach(episode => {
                  if (vm.cs.contentItems[showIndex] && vm.cs.contentItems[showIndex].seasons[seasonIndex]) {
                    const curEpisode = vm.cs.contentItems[showIndex].seasons[seasonIndex].episodes.find(e => e.episodeId === episode.episodeId)
                    if (curEpisode) {
                      if (vm.cs.$rentEnabled) {
                        episode.pricing.rent.amount = curEpisode.pricing.rent.amount
                      }
                      if (vm.cs.$buyEnabled) {
                        episode.pricing.buy.amount = curEpisode.pricing.buy.amount
                      }
                    }
                  }
                })
              }
            })
          }
        })
      }
      vm.tableState.last = data.last
    }
  })
    .then(() => {
      vm.getAllItems(vm.contentItems)

      vm.monetizationType.forEach(type => {
        if (vm.cs.pricing[type]?.paymentMethod === 'PER_ITEM') {
          vm.cs.pricing[type].amount = 0
        }

        if (vm.cs.pricing[type]?.paymentMethod === 'PER_SET') {
          vm.setAllPrices(type)
        }
      })
    })

  /**
   * Channel Set
   *
   * @memberof mwApp/packages.controller:EditAddonCtrl
   * @type {Object}
   */

  vm.selectedAll = false

  /**
   * Filter value for channel sets
   *
   * @memberof mwApp/packages.controller:EditAddonCtrl
   * @type {string}
   */
  vm.filter = ''

  /**
   * Filter value for assigned Channels
   *
   * @memberof mwApp/packages.controller:EditAddonCtrl
   * @type {string}
   */
  vm.filterAssigned = ''

  /**
   * Create or edit coupon, and close modal window afterwards
   *
   * @memberof mwApp/packages.controller:EditAddonCtrl
   */
  vm.submit = function () {
    if (!vm.cs.$buyEnabled && !vm.cs.$rentEnabled) {
      return
    }
    vm.cs.contentItems = vm.contentItems

    vm.monetizationType.forEach(type => {
      if (vm.cs.pricing[type]?.paymentMethod === 'PER_ITEM') {
        vm.cs.pricing[type].amount = vm.allItems.map(i => i.pricing[type].amount).reduce((price, amount) => +(amount === price) && price)
      }
    })

    if (vm.type === 'channelSets' && vm.cs.pricing.rent.$periodType === 'DUE_DATE') {
      vm.cs.pricing.rent.autoPay = false
    }

    //   .filter((item, index) => {
    //   if (vm.cs.$rentEnabled && vm.cs.$buyEnabled) {
    //     if ([vm.showSet_types.season, vm.showSet_types.episode].includes(vm.cs.itemType)) {
    //       item.seasons = item.seasons.filter((season, seasonIndex) => {
    //         if (vm.showSet_types.episode === vm.cs.itemType) {
    //           season.episodes = season.episodes.filter((episode, episodeIndex) => {
    //             return episode.pricing.rent.amount !== vm.cachedContentItems[index].seasons[seasonIndex].episodes[episodeIndex].pricing.rent.amount || episode.pricing.buy.amount !== vm.cachedContentItems[index].seasons[seasonIndex].episodes[episodeIndex].pricing.buy.amount
    //           })
    //           return season.episodes.length > 0
    //         }
    //         return season.pricing.rent.amount !== vm.cachedContentItems[index].seasons[seasonIndex].pricing.rent.amount || season.pricing.buy.amount !== vm.cachedContentItems[index].seasons[seasonIndex].pricing.buy.amount
    //       })
    //       return item.seasons.length > 0
    //     }
    //     return item.pricing.rent.amount !== vm.cachedContentItems[index].pricing.rent.amount || item.pricing.buy.amount !== vm.cachedContentItems[index].pricing.buy.amount
    //   }
    //   if (vm.cs.$rentEnabled) {
    //     if ([vm.showSet_types.season, vm.showSet_types.episode].includes(vm.cs.itemType)) {
    //       item.seasons = item.seasons.filter((season, seasonIndex) => {
    //         if (vm.showSet_types.episode === vm.cs.itemType) {
    //           season.episodes = season.episodes.filter((episode, episodeIndex) => {
    //             return episode.pricing.rent.amount !== vm.cachedContentItems[index].seasons[seasonIndex].episodes[episodeIndex].pricing.rent.amount
    //           })
    //           return season.episodes.length > 0
    //         }
    //         return season.pricing.rent.amount !== vm.cachedContentItems[index].seasons[seasonIndex].pricing.rent.amount
    //       })
    //       return item.seasons.length > 0
    //     }
    //     return item.pricing.rent.amount !== vm.cachedContentItems[index].pricing.rent.amount
    //   }
    //   if (vm.cs.$buyEnabled) {
    //     if ([vm.showSet_types.season, vm.showSet_types.episode].includes(vm.cs.itemType)) {
    //       item.seasons = item.seasons.filter((season, seasonIndex) => {
    //         if (vm.showSet_types.episode === vm.cs.itemType) {
    //           season.episodes = season.episodes.filter((episode, episodeIndex) => {
    //             return episode.pricing.buy.amount !== vm.cachedContentItems[index].seasons[seasonIndex].episodes[episodeIndex].pricing.buy.amount
    //           })
    //
    //           return season.episodes.length > 0
    //         }
    //         return season.pricing.buy.amount !== vm.cachedContentItems[index].seasons[seasonIndex].pricing.buy.amount
    //       })
    //       return item.seasons.length > 0
    //     }
    //     return item.pricing.buy.amount !== vm.cachedContentItems[index].pricing.buy.amount
    //   }
    // })
    $uibModalInstance.close()
  }

  /**
   * Method for displaying buttons
   *
   * @memberof mwApp/packages.controller:editAddonsCtrl
   */
  vm.showApplyButton = function (obj, value) {
    return value && obj && !Object.keys(obj).length
  }

  /**
   * Method for change price for selected
   *
   * @param {String} type
   * @param {Number} value
   * @param evt
   * @memberof mwApp/packages.controller:editAddonsCtrl
   */
  vm.applyPrice = function (type, value, evt) {
    evt.preventDefault()
    evt.stopPropagation()

    vm.allItems.filter(i => i.selected && vm.filterContent(i)).forEach(i => { i.pricing[type].amount = value })
  }

  /**
   * Method for select all content
   *
   * @memberof mwApp/packages.controller:editAddonsCtrl
   */
  vm.selectAll = function () {
    vm.allItems.filter(vm.filterContent).forEach(i => { i.selected = vm.selectedAll })
  }

  /**
   * Method for changing selectAll
   *
   * @param {Boolean} selected
   * @memberof mwApp/packages.controller:editAddonsCtrl
   */
  vm.changeSelect = vm.filterChanged = function (selected = true) {
    vm.selectedAll = selected && vm.allItems.filter(vm.filterContent).every(i => i.selected)
  }

  /**
   * Method for filtering content by name
   *
   * @param {Object} content
   * @memberof mwApp/packages.controller:editAddonsCtrl
   */
  vm.filterContent = function (content) {
    const name = content.tvShowName || content.contentName

    if (!vm.filter.length || !name) {
      return true
    }
    const filter = vm.filter.toLowerCase()

    return name.toLowerCase().includes(filter)
  }

  const changeHandler = (form) => {
    form.priceSettings_to.$setTouched()
    const toActual = new Date(vm.cs.pricing.rent.$dueDate?.setHours(23, 59, 59, 999))
    const minError = vm.dpCfg.minDate > toActual
    form.priceSettings_to.$setValidity('min', !minError)
  }

  /**
   * Datepicker default settings
   *
   * @memberof mwApp/reports.controller:AddSubscriptionSettingsCtrl
   * @type {{format : string}}
   */
  vm.dpCfg = {
    format: 'dd.MM.yyyy',
    minDate: moment().endOf('day').toDate(),
    changeHandler: changeHandler
  }

  /**
   * Handle open datepicker
   *
   * @memberof mwApp/reports.controller:AddSubscriptionSettingsCtrl
   */
  vm.open = function () {
    vm.dpCfg.opened = true
  }

  vm.onCsTransition = function () {
    vm.cancel()
    $location.url(vm.cs._publicUrl)
  }

  vm.requiredTimeUnit = function () {
    if (vm.type === 'channelSets') {
      return vm.cs.pricing.rent.rentLengthOverride
    }
    return vm.cs.$rentEnabled
  }

  /**
   * Cancel assigning, close modal window
   *
   * @memberof mwApp/subscribers.controller:ChangePackageCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
